module.exports = __webpack_public_path__ + "static/images/4_snowy_night.863c3f7f.jpg";